/* ============================================================
   VIVAMACITY — Scroll Reveal
   Gentle fade-up as sections enter the viewport, staggered for
   grids. Progressive enhancement: if reduced-motion is set or
   IntersectionObserver is unavailable, nothing is ever hidden.
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Bail out cleanly — content stays fully visible.
  if (prefersReduced || !('IntersectionObserver' in window)) return;

  // Selector groups. `stagger: true` cascades siblings by index.
  var GROUPS = [
    { sel: '.viva-editorial-img, .viva-editorial-text' },
    { sel: '.viva-cats-eyebrow' },
    { sel: '.viva-product-edit-head' },
    { sel: '.viva-prod-card', stagger: true },
    { sel: '.viva-mood-content' },
    { sel: '.viva-press-inner' },
    { sel: '.viva-story-img, .viva-story-text' },
    {
      sel:
        '.newsletter-section .section-header, ' +
        '.newsletter-section .newsletter__wrapper, ' +
        '.newsletter-section form'
    }
  ];

  function init() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    GROUPS.forEach(function (group) {
      var nodes = document.querySelectorAll(group.sel);
      Array.prototype.forEach.call(nodes, function (node, i) {
        if (node.hasAttribute('data-viva-reveal')) return;
        node.setAttribute('data-viva-reveal', '');
        if (group.stagger) {
          node.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        }
        observer.observe(node);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
